import bundledJquery from "../../node_modules/jquery/dist/jquery.js";

const globalJquery = window.jQuery || window.$;
const jquery = globalJquery && globalJquery.fn && globalJquery.event ? globalJquery : bundledJquery;

window.jQuery = jquery;
window.$ = jquery;

export default jquery;
export const $ = jquery;
